import { CronoResponse } from 'crono-fe-common/types/response';

export const parseFindNewData = <T>(
  body: CronoResponse<T> | null | undefined,
): T | null => body?.data ?? null;

const ONE_HOUR_MS = 60 * 60 * 1000;

export const findNewQueryCacheOptions = {
  staleTime: ONE_HOUR_MS,
  cacheTime: ONE_HOUR_MS,
} as const;

const FIND_NEW_QUERY_KEY = 'findNew';

/**
 * Single source of truth for the FindNew React Query keys. Every `fetchQuery`
 * across the FindNew hooks builds its key here so a lookup shares one cache
 * entry regardless of which hook triggered it — e.g. a numeric-id company
 * resolved via `useCompanyInfoWithFallback` and via
 * `useCompanyInfoByNumericIdWithFallback` collide on the same key.
 */
export const findNewQueryKeys = {
  company: (publicId: string | null | undefined) =>
    [FIND_NEW_QUERY_KEY, 'company', publicId] as const,
  companyByNumericId: (numericId: string | number | null | undefined) =>
    [FIND_NEW_QUERY_KEY, 'company', 'byNumericId', String(numericId)] as const,
  companyResolve: (publicId: string) =>
    [FIND_NEW_QUERY_KEY, 'company', 'resolve', publicId] as const,
  contact: (publicId: string | null | undefined, withOtherFields: boolean) =>
    [FIND_NEW_QUERY_KEY, 'contact', publicId, withOtherFields] as const,
};
